const CACHE_PREFIX = "ms_cache_";
// 7 days TTL — long enough to survive weekend offline use
const CACHE_TTL = 7 * 24 * 60 * 60 * 1000;

export const saveToCache = (key, data) => {
  try {
    localStorage.setItem(
      CACHE_PREFIX + key,
      JSON.stringify({ data, timestamp: Date.now() })
    );
  } catch {
    // localStorage full — clear old entries and retry
    clearOldCache();
    try {
      localStorage.setItem(
        CACHE_PREFIX + key,
        JSON.stringify({ data, timestamp: Date.now() })
      );
    } catch {
      // Silent fail
    }
  }
};

export const loadFromCache = (key) => {
  try {
    const raw = localStorage.getItem(CACHE_PREFIX + key);
    if (!raw) return null;
    const { data, timestamp } = JSON.parse(raw);
    // Return cache regardless of age when offline
    if (!navigator.onLine) return data;
    // Online — check TTL
    if (Date.now() - timestamp > CACHE_TTL) return null;
    return data;
  } catch {
    return null;
  }
};

export const clearOldCache = () => {
  try {
    const keys = Object.keys(localStorage).filter(k => k.startsWith(CACHE_PREFIX));
    keys.forEach(k => localStorage.removeItem(k));
  } catch {
    // Silent fail
  }
};

export const isOnline = () => navigator.onLine;

export const formatDate = (dateStr) => {
  try {
    return new Date(dateStr).toLocaleDateString("en-NG", {
      timeZone: "Africa/Lagos",
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};